/* eslint-disable @typescript-eslint/unbound-method */
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiError, ApiSuccessfulLogin } from 'src/app/interfaces/api';
import { AuthService } from 'src/app/services/auth.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgIf,
    ],
})
export class LoginComponent implements OnInit {
  public loginForm!: UntypedFormGroup;

  public loginNotFound = false;

  public notAdminError = false;

  public loggingIn = false;

  public otherErrorMessage = '';

  public otherError: boolean = false;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    public readonly authService: AuthService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.authService.sanctumCSRF().subscribe({
      next: () => {
        this.authService.csrfLoaded = true;
      },
    });

    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  public get formControl(): {
    [key: string]: AbstractControl;
  } {
    return this.loginForm.controls;
  }

  public onLogin(): void {
    this.loginNotFound = false;

    if (this.loginForm.invalid) {
      return;
    }

    if (this.authService.csrfLoaded) {
      this.loggingIn = true;
      this.authService
        .reportEmailLogin(
          String(this.loginForm.get('email')?.value),
          String(this.loginForm.get('password')?.value)
        )
        .subscribe({
          next: (user) => {
            this.authService.login(<ApiSuccessfulLogin>user);
            this.router.navigate(['/eis/home']).finally(() => false);
          },
          error: (err: ApiError) => {
            this.loggingIn = false;
            if (err.status === 401) {
              this.loginNotFound = true;

              if (err.error?.message === 'Not Admin') {
                this.notAdminError = true;
              }
            } else {
              this.otherError = true;
              this.otherErrorMessage =
                'There was an error processing your login. Please refresh the page and try again.';
            }
          },
          complete: () => {
            this.loggingIn = false;
          },
        });
    } else {
      this.otherErrorMessage =
        'There was an error logging you in. Please refresh the page and try again.';
    }
  }
}
